import React from 'react';
import { LucideIcon } from 'lucide-react';

export interface PageHeaderProps {
  badgeText: string;
  badgeIcon?: LucideIcon;
  title: string;
  titleBadge?: string | number;
  children?: React.ReactNode;
  isDark?: boolean;
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  badgeText,
  badgeIcon: BadgeIcon,
  title,
  titleBadge,
  children,
  isDark = false,
}) => {
  return (
    <div className={`${isDark ? 'header-banner-dark' : 'header-banner'} flex-col items-start justify-center gap-3 p-4 sm:p-6 h-auto w-full`}>
      <div className="min-w-0 w-full">
        <span
          className={`text-[9px] sm:text-[10px] font-extrabold px-2 sm:px-2.5 py-0.5 rounded border uppercase tracking-wider inline-flex items-center gap-1 shrink-0 ${
            isDark
              ? 'text-amber-400 bg-slate-800 border-slate-700'
              : 'text-asmm-red bg-red-50 border-red-100'
          }`}
        >
          {BadgeIcon && <BadgeIcon className="w-3 h-3 sm:w-3.5 sm:h-3.5" />}
          {badgeText}
        </span>
        <div className="flex items-center gap-2 mt-1 flex-wrap">
          <h2 className="text-lg sm:text-2xl font-extrabold leading-tight text-slate-900">
            {title}
          </h2>
          {titleBadge !== undefined && (
            <span className="text-xs font-extrabold bg-red-50 text-asmm-red border border-red-100 px-2.5 py-0.5 rounded-full">
              {titleBadge}
            </span>
          )}
        </div>
      </div>

      {children && (
        <div className="w-full flex items-center justify-end gap-2 pt-1 flex-wrap">
          {children}
        </div>
      )}
    </div>
  );
};
